import { useState } from "react";
import { useAuth } from "../../services/AuthContext";
import { Navigate } from "react-router-dom";
import {
  Box,
  Button,
  Card,
  Checkbox,
  FormControlLabel,
  TextField,
  Typography,
  useTheme,
} from "@mui/material";
import ThemeToggleButton from "../../contexts/ThemeToggleButton";

export const LoginPage = () => {
  const { user, login } = useAuth();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const theme = useTheme();

  if (user) return <Navigate to="/" replace />;

  const handleSubmit = async () => {
    setError("");
    try {
      await login(username, password);
    } catch (err) {
      setError("Invalid username or password: " + err);
    }
  };

  return (
    <Box
      sx={{
        minHeight: "87vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        px: 2,
        background:
          theme.palette.mode === "light"
            ? "#f8fafc" : "#0f172a"
      }}
    >
      {/* Dark/Light Toggle */}
      <ThemeToggleButton />

      <Card
        elevation={6}
        sx={{
          width: "100%",
          maxWidth: 420,
          p: 4,
          borderRadius: 3,
          display: "flex",
          flexDirection: "column",
          gap: 3,
        }}
      >
        <Typography
          variant="h5"
          fontWeight={700}
          textAlign="center"
          sx={{ color: theme.palette.text.primary }}
        >
          MineProd Login
        </Typography>

        {error && (
          <Typography color="error" variant="body2" textAlign="center">
            {error}
          </Typography>
        )}

        <TextField
          label="Username"
          variant="outlined"
          fullWidth
          value={username}
          onChange={(e) => setUsername(e.target.value)}
        />

        <TextField
          label="Password"
          type="password"
          variant="outlined"
          fullWidth
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />

        <Button
          variant="contained"
          size="large"
          fullWidth
          sx={{
            py: 1.2,
            fontWeight: 600,
            background: "linear-gradient(135deg, #667eea 0%, #4c5fd7 100%)",
            "&:hover": {
              background: "linear-gradient(135deg, #4c5fd7 0%, #c2410c 100%)",
            },
          }}
          onClick={handleSubmit}
        >
          Login
        </Button>
      </Card>
    </Box>
  );
};